import { render, staticRenderFns } from "./FeaturesSelf.vue?vue&type=template&id=35ce2b2a&scoped=true&"
import script from "./FeaturesSelf.vue?vue&type=script&lang=js&"
export * from "./FeaturesSelf.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesSelf.vue?vue&type=style&index=0&id=35ce2b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce2b2a",
  null
  
)

export default component.exports